const formatPointsNumbers = (value) =>
  value?.toFixed(2)?.replace(/\d(?=(\d{3})+\.)/g, '$&,')

export default formatPointsNumbers
